import { render, staticRenderFns } from "./LogMain.vue?vue&type=template&id=c6477d42"
import script from "./LogMain.vue?vue&type=script&lang=ts"
export * from "./LogMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports